import React from "react";
import "./UserSplash.css";

function UserSplash() {
    return(
        <div className="image-container">
            
        </div>
    )
}

export default UserSplash;